<template>
  <div class="login-page">
    <a-card title="登录" class="login-card">
      <a-form :model="form" @finish="onSubmit">
        <a-form-item name="username" :rules="[{ required: true, message: '请输入用户名' }]">
          <a-input v-model:value="form.username" placeholder="用户名" />
        </a-form-item>
        <a-form-item name="password" :rules="[{ required: true, message: '请输入密码' }]">
          <a-input-password v-model:value="form.password" placeholder="密码" />
        </a-form-item>
        <a-button type="primary" html-type="submit" :loading="loading" block>登录</a-button>
      </a-form>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { login } from '../api/auth';
import { message } from 'ant-design-vue';

const router = useRouter();
const form = reactive({ username: '', password: '' });
const loading = ref(false);
const onSubmit = async () => {
  loading.value = true;
  try {
    await login(form.username, form.password);
    message.success('登录成功');
    router.push('/');
  } catch (e: any) {
    message.error(e.response?.data?.error?.message || '登录失败');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #f5f7fa;
}

.login-card {
  width: 360px;
  max-width: 100%;
}
</style>
